import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";
import { acceptAll, rejectAll, getStoredConsent } from "../lib/consent";

export default function CookieBanner() {
  const { t, localePath } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = getStoredConsent();
    if (!stored) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white shadow-2xl"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-5 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:gap-8 lg:px-8">
        <div className="max-w-3xl">
          <h2 className="font-serif text-lg text-[#0B2447]">
            {t("cookie_banner.title")}
          </h2>
          <p className="mt-1 text-sm text-slate-600">
            {t("cookie_banner.text")}{" "}
            <Link
              to={localePath("cookies")}
              data-testid="cookie-banner-policy-link"
              className="text-[#C56E4E] underline underline-offset-2"
            >
              {t("cookie_banner.policy_link")}
            </Link>
            .
          </p>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={() => {
              rejectAll();
              setVisible(false);
            }}
            data-testid="cookie-banner-reject"
            className="border border-slate-300 px-5 py-2.5 text-sm font-medium text-slate-700 hover:border-slate-500"
          >
            {t("cookie_banner.reject")}
          </button>
          <button
            type="button"
            onClick={() => {
              acceptAll();
              setVisible(false);
            }}
            data-testid="cookie-banner-accept"
            className="bg-[#0B2447] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#0e2c58]"
          >
            {t("cookie_banner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
